import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { ContentBodyLogiInternoEmpresa } from '../../components/login/ContentBodyLogiInternoEmpresa'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const LoginEmpresa = () =>{
  /* A hook that is used to change the state of the menu. */
  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext);
  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false);
    }
  }
  const navigate = useNavigate();
  const olvidarContraseña = () => {
    navigate('/recuperarContraseña');
  }
  //<div onClick={navegar}>Si no itiene cuenta, <b>regístrese aquí.</b></div>
  return (
    <div className='Login' onClick={closeMenu}>
      <div className='headerLogin'> <HeaderHome /> </div>
      <div className='bodyLogin'>
        <div className='contentBodyLogin'>
          <ContentBodyLogiInternoEmpresa
            olvidarContraseña={olvidarContraseña}
            />
        </div>
        <div className='footerLogin'> <MiFooter /> </div>
      </div>
    </div>
  )
}

export default LoginEmpresa;
